module.exports = __webpack_public_path__ + "static/media/5_5-7_new.5254bf95.jpg";